
import { GadgetAPI } from '../../services/gadget-api.service.js'

const tigaGadgetInitialState = {
  deviceTypes: [],
  loadingDeviceTypes: false,
  deviceMakes: [],
  loadingMakesTypes: false,
  deviceModels: [],
  loadingDeviceModels: false,
  developerExceptions: []
}

export const tigaGadgetModule = {
  namespaced: true,
  state: tigaGadgetInitialState,
  actions: {
    fetchDeviceTypes ({ commit }) {
      commit('setDeviceTypesLoading', true)
      GadgetAPI.getDeviceTypes()
        .then((response) => {
          let { data } = response.data
          commit('setDeviceTypes', data)
        })
        .catch((error) => {
          commit('addDeveloperException', error)
        })
        .finally(() => commit('setDeviceTypesLoading', false))
    },
    fetchDeviceMakes ({ commit }, deviceTypeId) {
      commit('setDeviceMakesLoading', true)
      GadgetAPI.getDeviceMakes(deviceTypeId)
        .then((response) => {
          let { data } = response.data
          commit('setDeviceMakes', data)
        })
        .catch((error) => {
          commit('addDeveloperException', error)
        })
        .finally(() => commit('setDeviceMakesLoading', false))
    },
    fetchDeviceModels ({ commit }, payload) {
      commit('setDeviceModelsLoading', true)
      let { deviceTypeId, deviceMakeId } = payload
      GadgetAPI.getDeviceModels(deviceTypeId, deviceMakeId)
        .then((response) => {
          let { data } = response.data
          commit('setDeviceModels', data)
        })
        .catch((error) => {
          commit('addDeveloperException', error)
        })
        .finally(() => commit('setDeviceModelsLoading', false))
    },
    resetDeviceMakes ({ commit }) {
      commit('setDeviceMakes', null)
    },
    resetDeviceModels ({ commit }) {
      commit('setDeviceModels', null)
    }
  },
  mutations: {
    addDeveloperException: (state, payload) => {
      state.developerExceptions.push(payload)
    },
    setDeviceTypesLoading: (state, payload) => {
      state.deviceTypesLoading = payload
    },
    setDeviceTypes: (state, payload) => {
      state.deviceTypes = payload
    },
    setDeviceMakesLoading: (state, payload) => {
      state.deviceMakesLoading = payload
    },
    setDeviceMakes: (state, payload) => {
      state.deviceMakes = payload
    },
    setDeviceModelsLoading: (state, payload) => {
      state.deviceModelsLoading = payload
    },
    setDeviceModels: (state, payload) => {
      state.deviceModels = payload
    }
  },
  getters: {
    deviceTypes: state => {
      return state.deviceTypes
    },
    deviceMakes: state => {
      return state.deviceMakes
    },
    deviceMakesLoading: state => {
      return state.deviceMakesLoading
    },
    deviceMakeLabelById: ({ deviceMakes }) => (id) => {
      if (deviceMakes && deviceMakes.length > 0) {
        let arr = deviceMakes.filter(m => m.id === id)
        return arr.length > 0 ? arr[0].label : null
      }
      return null
    },
    deviceModels: state => {
      return state.deviceModels
    },
    deviceModelsLoading: state => {
      return state.deviceModelsLoading
    },
    deviceModelLabelById: ({ deviceModels }) => (id) => {
      if (deviceModels && deviceModels.length > 0) {
        let arr = deviceModels.filter(m => m.id === id)
        return arr.length > 0 ? arr[0].label : null
      }
      return null
    }
  }
}
